import store from '../../../store';

export default async questionId => {
	const question = await store.model.Question.findById(questionId, {
		include: [
			{
				relation: 'documents',
				scope: {
					include: [
						{
							relation: 'file',
							scope: {
								order: 'sort asc'
							}
						}
					]
				}
			}
		]
	});
	
	const files = question.documents().map(document => ({
		id: document.id,
		name: document.name,
		pages: document.file().map(file => file.path)
	}));
	
	return {
		id: questionId,
		name: question.title,
		files,
	};
}
